import { Link } from 'react-router-dom';
import RenderSortIcon from "Components/Datatable/RenderSortIcon";
import { TableIconTextButton } from 'Components/Button';
import { getRandomInt } from 'Utils/utilityFunctions';

/*
    
    name: Display Name for column header
    columnName: Array of multiple column keys to combine values of or key for one column
    delimiter: (optional) Delimeter to combine multiple column values with
    
    //concatColName: 

    formatFunction: (optional) Function applied to column value to format it
    wordBreak: (optional) 
        default - word-break: break-word
        "all" - word-break: break-all
    sortable: (optional) true/false
    
    //sortFieldNum:
    //isDataRow:

    title: (optional) Title for cell content

    isLink: (optional) true/false
    linkData: (required when isLink true) {
        pathname: "/manage/createDocument",
        text: "Edit", 
        state: updateState
    }

    isButton: (optional) true/false
    buttonData: (required when isButton true) { 
        action: handleDownload,     //Function to do when button is pressed
        text: null,                 //If null, value for column is used
        icon: ICONS.download.icon   //Icon for button, can be null
    }

    selectedRows: **Provided by Datatable Base**
    sortingInfo: **Provided by Datatable Base**
    
*/
export const Datatable_Column = ({ name, columnName, concatColName, selectedRows, sortable, sortFieldNum, delimiter, formatFunction, isDataRow, isLink, isButton, linkData, buttonData, sortingInfo, title, wordBreak }) => {
    
    

    var getColumnValue = function (row, columnName) {
        if (isDataRow != null && isDataRow == true) {
            return row;
        }
        else {
            var split = columnName.split(".");
            if (split.length > 1) {
                var value = row;
                for (var x = 0; x < split.length; x++) {
                    if (value != null) {
                        if (split[x] in value) {
                            value = value[split[x]];
                        }
                    }
                    else {
                        return value;
                    }
                }
                return value;
            }
            else {
                return row[columnName];
            }
        }
    }
    var getConcatRowColumns = function (row, colNames) {
        var response = "";
        if (formatFunction != null) {
            for (var i = 0; i < colNames.length; i++) {
                if (i == 0) {
                    response = formatFunction(row[colNames[i]], row);
                }
                else {
                    response = response + (delimiter != null ? delimiter : " ") + formatFunction(row[colNames[i]], row);
                }
            }
        }
        else {
            for (var i = 0; i < colNames.length; i++) {
                if (i == 0) {
                    response = row[colNames[i]];
                }
                else {
                    response = response + (delimiter != null ? delimiter : " ") + row[colNames[i]];
                }
            }
        }
        return response;
    }
    var getVarValue = function (value, params) {
        if (typeof value === 'function') {
            return value(params);
        }
        else {
            return value;
        }
    };

    function getValue (row, columnName) {
        if (formatFunction != null) {
            if (Array.isArray(columnName)) {
                return getConcatRowColumns(row, columnName)
            }
            else {
                return formatFunction(getColumnValue(row, columnName), row)
            }
        }
        else {
            if (Array.isArray(columnName)) {
                return getConcatRowColumns(row, columnName)
            }
            else {
                return getColumnValue(row, columnName);
            }
        }

    }


    var newColName = columnName;
    if (concatColName != null) {
        newColName = concatColName;
    }
    
    var sortColName = Array.isArray(columnName) ? columnName[0] : columnName;
    
    return {
        id: sortColName,
        name:
            <div className="datatable-col-name" >
                {name}
                {
                    sortable == true
                    ?   <div className="dataTableSortIcon">
                            <RenderSortIcon sortDirection={sortingInfo.sortingColumn == sortColName ? sortingInfo.sortingOrder : ""} />
                        </div>
                    :   null
                }

            </div>,
        selector: row => {
            var isB = getVarValue(isButton, { row: row });
            if (getVarValue(isLink,{ row: row }) == false || getVarValue(isLink,{ row: row }) == null) {
                if (isB == true) {
                    var buttonText = getVarValue(buttonData.text, { row: row });
                    //console.log(buttonText);
                    return (
                        <div className={"non-link-table-cell-data is-button " + (wordBreak!=null && wordBreak=="all" ? "is-break-all" : "")} title={title != null ? getVarValue(title, { rowName: row }) : ''}>
                            <TableIconTextButton onClick={() => buttonData.action(row)} className="table-action w-100" variant="table"  /*title={buttonData.title ? buttonData.title : ""}*///title='Download Report to View'
                                icon={buttonData.hasOwnProperty("icon") ? buttonData.icon : null}
                                content={
                                    <>
                                        {
                                            buttonText == null || buttonText == ""
                                            ?
                                                Array.isArray(columnName)
                                                ?   getConcatRowColumns(row, columnName)
                                                :   formatFunction != null
                                                    ?   formatFunction(getColumnValue(row, columnName), row)
                                                    :   getColumnValue(row, columnName)   
                                            : buttonText
                                        }
                                    </>
                                }
                            >
                            </TableIconTextButton>
                        </div>
                    );
                    //}
                }
                else{
                    return (
                        <div /*tabIndex={0}*/ className="non-link-table-cell-data" title={title != null ? getVarValue(title, { rowName: row }) : ''}>
                            {   
                                Array.isArray(columnName)
                                ?   getConcatRowColumns(row, columnName)
                                :   formatFunction != null
                                    ?   formatFunction(getColumnValue(row, columnName), row)
                                    :   getColumnValue(row, columnName)   
                            }
                        </div>
                    );
                }
            }
            else {
                var value = getValue(row, columnName);
                var compTitle = getVarValue(title, { rowName: value });
                var state = getVarValue(linkData.state, { rowName: row });
                var path = getVarValue(linkData.pathname, { row: row });
                var linkText = getVarValue(linkData.text, { row: row });

                if (path != null) {
                    return (
                        <Link className="table-action" /*tabIndex={0}*/
                            title={compTitle}
                            to={path + "/u/" + getRandomInt(0,1000)}
                            state={state}
                        >
                            {   
                                linkText == null || linkText == ""
                                ?   Array.isArray(columnName)
                                    ?   getConcatRowColumns(row, columnName)
                                    :   formatFunction != null
                                        ?   formatFunction(row[columnName], row)
                                        :   row[columnName]       
                                : linkText
                            }
                        </Link>
                    );
                }
                else {
                    return (
                        null
                    )
                }
            }
        },
        class: "test",
        sortable: sortable,
        sortField: sortFieldNum,
        sortColumnName: sortColName,
        conditionalCellStyles: [{
            when: (row) => {
                if ((selectedRows).some(i => i.id == row.id)) {
                    return true
                }
                else {
                    return false
                }
            },
            style: {
                boxShadow: "-2px 0px 0px 0px white, 2px 0px 0px 0px white",
            },
            classNames: ['selected-row'],
        }]
    };
}